import { flow, Instance, types } from 'mobx-state-tree'
import { track } from 'lib/babylistHealthAnalytics'
import ProductStateModel from './ProductStateModel'
import UIStateModel from './UIStateModel'
import { checkout as _checkout } from '../../requests'
import { EscapingActions } from './RootStateModel'
import { apiErrorResponseAdapter } from '../../utils'
import { STORE_NAME } from '../../constants'

const CartStateModel = types
  .compose(
    UIStateModel,
    types.model({
      product: types.optional(ProductStateModel, {}),
      lastCartItemAdded: types.maybe(types.string),
      includeFreeGift: types.optional(types.boolean, false),
    })
  )
  .actions((self) => {
    const checkout = flow(function* (
      actions: EscapingActions<APIResponse.Checkout> = {}
    ) {
      try {
        self.error = null
        self.isLoading = true
        const response = yield _checkout({
          cartItemIds: self.lastCartItemAdded
            ? [self.lastCartItemAdded]
            : undefined,
        })
        if (actions.onSuccess) {
          // Don't set `isLoading` to `false` here because we are navigating to
          // another page and want to avoid flashing the disabled state of the form
          actions.onSuccess(response)
        } else {
          self.isLoading = false
        }
      } catch (e: any) {
        track.errorThrown({
          storeName: STORE_NAME,
          eventLocation: 'None',
          error: JSON.stringify(e),
        })
        self.isLoading = false
        self.error = apiErrorResponseAdapter(e) as any
      }
    })

    const setLastItemAdded = (
      cartResponse: APIResponse.Cart,
      productId: number
    ) => {
      // Set the last item added based on the cart item matching the  product that was added.
      // In theory this should match exactly 1 element in the array.
      const cartItems = cartResponse.items.filter(
        (item) => item.productId === productId
      )
      if (cartItems.length) {
        self.lastCartItemAdded = cartItems[0].uuid
      }
    }

    const setIncludeFreeGift = (shouldInclude: boolean) => {
      self.includeFreeGift = shouldInclude
    }

    return { checkout, setLastItemAdded, setIncludeFreeGift }
  })
  .views((self) => ({
    get checkoutPayload() {
      return {
        includeFreeGift: self.includeFreeGift,
        cartItemIds: self.lastCartItemAdded
          ? [self.lastCartItemAdded]
          : undefined,
      }
    },
  }))

export default CartStateModel
export type CartStateModelType = Instance<typeof CartStateModel>
